import * as React from "react"

const MOBILE_BREAKPOINT = 768

// The breakpoint pixel itself belongs to the wide side (matches a
// `min-width: breakpoint` query), so the narrow query cuts off one px below it.
export function belowBreakpointQuery(breakpoint: number) {
  return `(max-width: ${breakpoint - 1}px)`
}

function subscribe(query: string, onChange: () => void) {
  const mql = window.matchMedia(query)
  mql.addEventListener("change", onChange)
  return () => mql.removeEventListener("change", onChange)
}

export function useIsMobile(breakpoint: number = MOBILE_BREAKPOINT) {
  const query = belowBreakpointQuery(breakpoint)
  return React.useSyncExternalStore(
    onChange => subscribe(query, onChange),
    () => window.matchMedia(query).matches,
    () => false,
  )
}
